import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    orderdDaysTab: "today",
    orderStartDate: "",
    orderEndDate: "",
    voucherTab: "Order",
    selectedFilter: "All",
    selectedWarehouseId: "",
    selectedManagerID: "",
    fromWarehouse: "",
    toWarehouse: "",
    selectedYear: "2025-2026",
    keyword: "",
    selectedOption: "",
    meTab: "All",
  },
  pagination: {
    page: 1,
    pages: 1,
  },
  ui: {
    isSearchBarOpen: false,
  },
  data: {
    orders: [],
  },
};

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setUi: (state, action) => {
      state.ui = { ...state.ui, ...action.payload };
    },
    setData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    addOrder: (state, action) => {
      state.data.orders.unshift(action.payload);
    },
    upsertOrder: (state, action) => {
      const incoming = action.payload;
      const idx = state.data.orders.findIndex(
        (o) => Number(o.orderId) === Number(incoming.orderId),
      );
      if (idx !== -1) {
        state.data.orders[idx] = { ...state.data.orders[idx], ...incoming };
      } else {
        state.data.orders.unshift(incoming);
      }
    },
    resetAll: () => initialState,
  },
});

export const {
  setFilter,
  setPagination,
  setUi,
  setData,
  addOrder,
  upsertOrder,
  resetAll,
} = orderSlice.actions;

export default orderSlice.reducer;
